import {
  ProductDTO,
  SearchResultDTOTypeEnum,
  TeamWithBreachesDTO,
} from '@atlassiansox/phobos-client-ts';
import React, { FC } from 'react';
import Badge from '@atlaskit/badge';

import { BreachCount } from '@/components/primitive';
import { PrimaryType } from '@/meta';

import SearchListName from '../search/search-results/search-list-titles/search-list-name';
import { SearchResultItemType } from '../search/search-results/types';

import * as stylesLocal from './styles';

type DashboardBasicListItemProps = {
  entity: ProductDTO | TeamWithBreachesDTO;
  type: PrimaryType;
};

const DashboardBasicListItem: FC<DashboardBasicListItemProps> = ({ entity, type }) => {
  const { breaches, name, publicId, description } = entity as ProductDTO | TeamWithBreachesDTO;
  const { qualityIssues, totalSLOs } = entity as ProductDTO;
  const item: SearchResultItemType = { name, publicId } as SearchResultItemType;

  return (
    <li>
      <div
        css={[
          stylesLocal.dashboardBasicListResultRowStyles,
          type === 'team' ? stylesLocal.dashboardBasicListTeamResultRowStyles : '',
        ]}
      >
        <SearchListName item={item} type={type.toUpperCase() as SearchResultDTOTypeEnum} />
        <div>{description}</div>
        <BreachCount count={breaches} />
        {type === 'product' && <BreachCount isWarning count={qualityIssues} />}
        <div>
          <Badge max={Infinity} appearance="default">
            {totalSLOs}
          </Badge>
        </div>
      </div>
    </li>
  );
};

export default DashboardBasicListItem;
